import { LICENSE_KEY } from "./tap/config/constants";
import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey(LICENSE_KEY);

// AG Grid Enterprise setup - must be loaded before any AG Grid components
import "ag-grid-enterprise";
